<div class="pc-chart" *ngIf="data">
  <div class="pc-breadcrumb" *ngIf="drillPath.length">
    <button type="button" class="pc-breadcrumb-item" (click)="drillTo(-1)">{{ rootLabel }}</button>
    <ng-container *ngFor="let node of drillPath; let i = index">
      <span class="pc-breadcrumb-sep">&rsaquo;</span>
      <button type="button" class="pc-breadcrumb-item" (click)="drillTo(i)">{{ node.name }}</button>
    </ng-container>
  </div>
  <div #pcHost [id]="$any(data).widgetId" class="pc-chart-host" [style.height]="hostHeight"></div>
</div>
